<template>
  <div class="c-favorite">
    <h1 class="c-favorite--heading">
      <img :src="require('@/assets/icon-search-history.png')">
      検索履歴
    </h1>
    <loading v-if="!isReady"/>
    <div v-else>
      <p class="c-favorite--count">{{count}}件</p>
      <ul v-if="count > 0" class="c-favorite--list">
        <button class="c-favorite--alldelete" @click="deleteAll"><img :src="require('@/assets/icon-trash-can.png')">すべて削除する</button>
        <li class="c-favorite--list--item" v-for="(item, index) in list" :key="index">
          <a :href="item.url" class="c-favorite--list--item__link">
            <p class="c-favorite--list--item__link__word">{{item.page_name}}</p>
            <p class="c-favorite--list--item__link__count">{{item.count}}件</p>
          </a>
          <button class="c-favorite--list--item__link__delete" @click="deleteItem(item.id)"><img :src="require('@/assets/icon-trash-can.png')">削除する</button>
        </li>
      </ul>
      <common-pager
        :update="updatePage"
        :size="pageSize"
        :count="count"
        :page="page"
        />
    </div>
    <div v-if="count <= 0" class="c-favorite--noprops">検索履歴はありません</div>
  </div>
</template>

<script>
import MixinUtil from '@/plugins/mixin-utils';
import IsMobileMixin from '@/plugins/isMobile';
import MixinMeta from '@/plugins/mixin-meta';
import CommonPropertyCard from '@/components/parts/CommonPropertyCard';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';
import Loading from '@/components/common/Loading';
import CommonPager from '@/components/common/Pager';

const querystring = window.location.search;
const query = [...new URLSearchParams(querystring).entries()]
  .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});

export default {
  name: 'SearchHistoryContents',
  mixins: [MixinUtil, IsMobileMixin, BehaviorLogMixin, MixinMeta],
  components: {
    CommonPropertyCard,
    Loading,
    CommonPager,
  },
  data() {
    return {
      list: [],
      isReady: false,
      count: 0,
      page: 1,
      pageSize: 10,
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    '$store.state.search': function (newValue) {
      this.updateData(newValue);
    },
  },
  async created() {
    this.metaSetForDefault('searchhistory');
    const page = query.page ? parseInt(query.page, 10) : 1;
    if (this.list === null) this.list = [];
    // this.updateList();
    await this.fetchHistory(page);
    this.isReady = true;
    // Footer表示フラグ更新
    await this.$store.commit('setFooterDisplayFlag');
  },
  methods: {
    async fetchHistory(page) {
      await this.retrieveSiteQueryLogs(page);
    },
    updateData(data) {
      this.list = data.data;
      this.page = data.currentPage;
      this.count = data.found;
      this.pageSize = data.pageSize;
    },
    updatePage(page = 1) {
      let url = location.origin;
      url += '/history/search/';
      // page
      url += `?page=${page}`;

      location.href = url;
    },
    async deleteItem(logId) {
      await this.deleteSiteQueryLog(logId);
    },
    async deleteAll() {
      await this.deleteAllSiteQueryLogs();
    },
  },
};
</script>

<style scoped lang="scss">
@charset "UTF-8";

.c-favorite {
  background-color: #FAFAFA;
  position: relative;
  &--alldelete {
    display:flex;
    justify-content: center;
    align-items: center;
    width:144px;
    height:44px;
    border: 1px solid #CCC;
    border-radius: 22px;
    position: absolute;
    right:40px;
    top: -64px;
    font-size: 14px;
    z-index:100;
    background-color: #FFF;
    img{
      width: 24px;
      height: 24px;
    }
  }
  &--heading {
    width:100%;
    text-align: center;
    font-size:20px;
    font-weight: bold;
    padding-top: 40px;
    img {
      width: 24px;
      height: 24px;
    }
  }
  &--count {
    width:100%;
    text-align: center;
    margin-top:30px;
    font-size:20px;
    font-weight: bold;
  }
  &--noprops {
    height:calc(100vh - 365px);
    width: 100%;
    display:flex;
    justify-content: center;
    align-items: center;
  }
  &--list {
    margin: 30px auto;
    width: 100%;
    max-width: 960px;
    position: relative;
    &--item {
      display:block;
      width: calc(100% - 80px);
      margin: 20px 40px;
      position: relative;
      &__link {
        display:flex;
        align-items: center;
        width:100%;
        max-width:880px;
        height:60px;
        border: 1px solid #CCC;
        border-radius:30px;
        background-color: #FFF;
        position: relative;

        &__word {
          width: 80%;
          margin-left: 40px;
          font-size:16px;
          color: #E83532;
        }
        &__count {
          position:absolute;
          right: 170px;
          bottom: 22px;
        }
        &__delete {
          position:absolute;
          font-size:14px;
          bottom:16px;
          right:40px;
          img {
            width:24px;
            height:24px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px)  {

.c-favorite {
  background-color: #FAFAFA;
  position: relative;
  &--alldelete {
    right: calc(50% - 77px );
    top: 67px;
  }
  &--heading {
    position: absolute;
    top: 20px;
    width: 130px;
    z-index: 100;
    left: 0;
    margin: 0;
    padding: 0;
  }
  &--count {
    position: absolute;
    right: 10px;
    top: 23px;
    z-index: 100;
    text-align: right;
    margin: 0;
  }
  &--list {
    margin: auto;
    width: 100%;
    padding: 110px 0 0;
    max-width: 960px;
    &--item {
      position: relative;
      width: calc(100% - 20px);
      margin: 10px;
      &__link {
        height:88px;
        border-radius: 10px;
        align-items: baseline;
        padding:10px;
        &__word {
          margin:0;
          width: 100%;
          height:40px;
          line-height: 1.4em;
        }
        &__delete {
          bottom: 8px;
          right: 10px;
        }
        &__count {
          right: 0;
          bottom: 10px;
          left: 10px;
        }
      }
    }
  }
}

}

</style>
